import { environment } from "projects/StatusTracker/src/environments/environment";
import * as AfEnv from 'src/environments/environment';

const Controllers = {
  Localization: `${AfEnv.environment.LOCALIZATION_API_URL}Localization`,
  Setting: `${environment.STATUS_TRACKER_API_URL}AppSettings`,
  Authentication: `${environment.STATUS_TRACKER_API_URL}Authentication`,
  OrderStatus: `${environment.STATUS_TRACKER_API_URL}OrderStatus`,
  AdditionalDemand: `${environment.STATUS_TRACKER_API_URL}AdditionalDemand`,
  DemandJob: `${environment.STATUS_TRACKER_API_URL}DemandJob`,
  Tracker: `${environment.STATUS_TRACKER_API_URL}Tracker`,
  Document: `${environment.STATUS_TRACKER_API_URL}Document`,
  Invoice: `${environment.STATUS_TRACKER_API_URL}Invoice`,
  RepairStatus: `${environment.STATUS_TRACKER_API_URL}RepairStatus`,
  Notification: `${environment.STATUS_TRACKER_API_URL}Notification`,
  CarParking: `${environment.STATUS_TRACKER_API_URL}CarParking`,
  SmsService: `${environment.STATUS_TRACKER_API_URL}SmsService`,
  Appointment: `${environment.STATUS_TRACKER_API_URL}Appointment`,
  Services: `${environment.STATUS_TRACKER_API_URL}Services`,
  PaymentGateway: `${environment.STATUS_TRACKER_API_URL}PaymentGateway`
}

export const enum KeyValue {
  DefaultLanguage = 'en-US'
}

export const AppConfig = Object.freeze(
  {
    // repair status
    Validate: `${Controllers.Authentication}/Validate`,

    // Order Status APIs
    GET_ORDER_STATUS_DATA_API_URL: `${Controllers.Tracker}/GetServices`,
    UPDATE_CUSTOMER_ORDER_API_URL: `${Controllers.Tracker}/Update`,
    UPDATE_ALLCUSTOMER_ORDER_API_URL: `${Controllers.DemandJob}/ApproveAll`,
    UPDATE_ALLADDITIONAL_CUSTOMER_ORDER_API_URL: `${Controllers.AdditionalDemand}/ApproveAll`,
    GET_ORDER_STATUS_Header_DATA_API_URL: `${Controllers.Tracker}/Get`,
    CALL_DEALER_LOG_ENTRY_URL: `${Controllers.Tracker}/CallLog`,

    GET_ORDER_ServicePlans_DATA_API_URL: `${Controllers.OrderStatus}/Plans`,
    GET_BRANDS: `${Controllers.OrderStatus}/GetBrandList`,
    GET_CONFIGURED_STATUS_API_URL: `${Controllers.Tracker}/GetStatus`,
    GET_APPOINTMENT_ADDITIONALWORK_DETAIL:`${Controllers.AdditionalDemand}/Get`,
    GET_APPOINTMENT_DETAIL:`${Controllers.Appointment}/GetServices`,
    GET_INVOICE_PREVIEW:`${Controllers.Services}/GetPreview`,
    GET_POSTED_INVOICE:`${Controllers.Invoice}/GetByWo`,
    GET_INVOICE_DOCUMENT:`${Controllers.Invoice}/GetDocuments`,
    GET_DEMAND_DOCUMENT: `${Controllers.DemandJob}/DocumentCount`,
    SEND_CUSTOMER_APPROVAL: `${Controllers.DemandJob}/CustomerApproval`,

    UPDATE_ORDER_STATUS_API_URL: `${Controllers.OrderStatus}/Edit`,
    SERVICE_PRICE: `${Controllers.OrderStatus}/Price`,
    INVOICE_DETAILS: `${Controllers.Invoice}/Get`,
    // AUTHENTICATE_YOURSELF: `${Controllers.OrderStatus}/Authenticate`,
    AUTHENTICATION_DETAILS: `${Controllers.OrderStatus}/AuthenticationDetails`,
    VALIDATE_OTP: `${Controllers.OrderStatus}/ValidateOtp`,
    ADD_DIGITAL_SIGNATURE: `${Controllers.OrderStatus}/DigitalSignature`,

    TRACKER_INVOICE_DETAILS: `${Controllers.Invoice}/GetDetails`,
    APPOINTMENT_DETAILS: `${Controllers.Appointment}/Get`,
    APPOINTMENT_DEALER_DETAILS: `${Controllers.Tracker}/GetDealer`,
    APPOINTMENT_DOCUMENT_DETAILS: `${Controllers.Appointment}/GetServiceDocument`,

    GetCustomerNotifications: `${Controllers.Notification}/Get`,
    CustomerNotificationMarkAllAsRead: `${Controllers.Notification}/ReadAll`,
    CustomerNotificationMarkAsRead: `${Controllers.Notification}/Read`,

    //Notification APi URLs
    SEND_NOTIFICATION_API_URL: `${Controllers.Notification}/Send`,
    GEt_NOTIFICATION_BY_USER_API_URL: `${Controllers.Notification}/AllTemplateList`,
    GEt_NOTIFICATION_BY_USER_LIST: `${Controllers.Notification}/GetUserNotificationList`,

    MARK_NOTIFICATION_AS_READ_BY_ID_API_URL: `${Controllers.Notification}/Read`,
    MARK_NOTIFICATION_AS_READ: `${Controllers.Notification}/MarkAsReadUserNotification`,


    // Car Parking APIs
    GET_VEHICLE_PARKED_LOCATION_URL: `${Controllers.CarParking}/Get`,
    CUSTOMER_DROP_OFF_VEHICLE_MARKING_URL: `${Controllers.CarParking}/Add`,
    GET_VEHICLE_PARKED_BASE_URL: `${Controllers.CarParking}/GetImage`,

    //Common localization
    GET_COMMON_LOCALIZATION_LANGUAGE_API_URL: `${Controllers.Localization}/Languages`,
    GET_ADMIN_LOCALIZATION_API_URL: `${Controllers.Localization}/Application`,

    // theme APi
    GET_APPLICATION_THEME: `${Controllers.Localization}/Theme`,

    //setting API
    GetGenericSettings: `${Controllers.Setting}/GetGeneric`,
    GetSettings: `${Controllers.Setting}/Get`,
    GetFeature: `${Controllers.Setting}/Feature`,

    //Authentication API
    AUTHENTICATE_YOURSELF: `${Controllers.Authentication}/Authenticate`,

    
    UploadDocumentFromStatuTracker: `${Controllers.Document}/Upload`,
    GetDemandWiseDocumentCount :`${Controllers.Document}/Get`,
    DownloadFile: `${Controllers.OrderStatus}/DownloadFile`,
    DownloadDocument: `${Controllers.Document}/Download`,

    //Payment Gateway
    InvoicePayment: `${Controllers.Invoice}/Payment`,
    CheckPayment: `${Controllers.Invoice}/Check`,
    
  });
